import api from '../api';

const path = '/payment';

export const createPaymentRequest = async (values) => {
    const response = await api.post('/payment/create', values);
    return response;
};

export const checkPaymentStatusRequest = (orderId) => {
    return api.get(`${path}/status/${orderId}`);
};

export const getPaymentPlansRequest = () => api.get(`${path}/plans`);

export const getPaymentHistoryRequest = (limit = 10, offset = 0) => {
    return api.get(`${path}/history?limit=${limit}&offset=${offset}`);
};
